<script lang="ts">
  import { slide } from "svelte/transition";
  import { project } from "$lib/services/store";
  import { beforeNavigate } from "$app/navigation";
  import Group from "$lib/admin/components/Group.svelte";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";
  import InformationCircle from "virtual:icons/mdi/information-variant-circle-outline";
  import type { BlockStyling } from "@/src/types/components/Styling";

  interface ArticleAdProps {
    styling?: BlockStyling;
  }

  export let props: ArticleAdProps;
  export let adminView = false;

  let show = false;

  beforeNavigate(() => {
    if (show) {
      show = false;
    }
  });
</script>

{#if adminView}
  <Group addClass="form-item">
    <Group colspan="4-8">
      <p>This block has no configuration options.</p>
    </Group>
  </Group>
{:else}
  <div
    class="content-grid {props?.styling?.marginTop ?? ''} {props?.styling?.marginBottom ?? ''}"
    id="block-disclaimer">
    <button class="flex justify-end text-xs text-link" tabindex="0" on:click={() => (show = !show)}>
      <InformationCircle width="16" height="16" class="mr-2" />
      <Translate text="Affiliate disclosure" />
    </button>
    {#if show}
      <div class="text-xs mt-2" in:slide={{ duration: 200 }} out:slide={{ duration: 200 }}>
        <p>{@html $project.data?.affiliateDisclosure?.text ?? "No information yet.."}</p>
      </div>
    {/if}
  </div>
{/if}
